/*
    @module DataProvider
    Data provider register
 */
 define('shared/util/registers/DataProvider',['./Registrable', 'shared/lib/ctor', 'shared/lib/Emitter', 'shared/lib/RSVP'], 
function (Base, ctor, Emitter, RSVP) {

    var Ctor = ctor(function(){

    }).inherit(Base);

    var p = Ctor.prototype;

    p.register = function( entity ){

        Emitter( entity );

        return Base.prototype.register.apply(this, arguments);
    };

    Ctor.instance = new Ctor();

    return Ctor;
 });
